export default __webpack_public_path__ + "static/media/logoBlanco.30033bc1.png";